import { Box, Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Color } from 'src/theme/color';

const CreatorMenuItem = ({
	children,
	path,
	disabled,
}: {
	children: React.ReactNode;
	path: string;
	disabled?: boolean;
}) => {
	const location = useLocation();
	const { pathname } = location;

	return (
		<>
			{disabled ? (
				<Flex
					h="49px"
					border="none"
					pos="relative"
					alignItems="center"
					bgColor={pathname === path ? '#2A2A2A' : 'transparent'}
					opacity={disabled ? '0.6' : '1'}
					pointerEvents="none"
				>
					<Box
						position="absolute"
						h="100%"
						left="0"
						top="0"
						bg={pathname === path ? '#FF3F3F' : 'transparent'}
						w="4px"
					/>
					<Box paddingLeft="20px">{children}</Box>
				</Flex>
			) : (
				<Link to={path}>
					<Flex
						h="49px"
						border="none"
						pos="relative"
						alignItems="center"
						bgColor={pathname === path ? '#2A2A2A' : 'transparent'}
						opacity={disabled ? '0.6' : '1'}
						pointerEvents="none"
					>
						<Box
							position="absolute"
							h="100%"
							left="0"
							top="0"
							bg={pathname === path ? '#FF3F3F' : 'transparent'}
							w="4px"
						/>
						<Box paddingLeft="20px">{children}</Box>
					</Flex>
				</Link>
			)}
		</>
	);
};

export const CreatorMenu = () => {
	const { t } = useTranslation();
	return (
		<Flex flexDir="column">
			<CreatorMenuItem
				path="/creator"
				disabled
			>
				{t('dashboard.tab')}
			</CreatorMenuItem>
			<CreatorMenuItem path="/creator/games">{t('yourGames.tab')}</CreatorMenuItem>
			<CreatorMenuItem
				path="/creator/stats"
				disabled
			>
				{t('stats.tab')}
			</CreatorMenuItem>
			<CreatorMenuItem
				path="/creator/settings"
				disabled
			>
				{t('settings.tab')}
			</CreatorMenuItem>
		</Flex>
	);
};
